import gql from 'graphql-tag';

export interface FlagEvaluationGql {
  flagName: string;
  value: string;
}

export const EVALUATE_FLAGS_QUERY = gql`
  query EvaluateFlags {
    evaluateFlags {
      flagName
      value
    }
  }
`;

export const FLAG_UPDATED_SUBSCRIPTION = gql`
  subscription FlagUpdated {
    flagUpdated {
      flagName
      value
    }
  }
`;
